import { jsx } from "react/jsx-runtime";
import { StyledObfuscatedText } from "./obfuscated-text.styles.js";
import "@mui/material";
const OBFUSCATED_TEXT_DATA_ID = "obfuscated-text";
const ObfuscatedText = ({ children, isVisible = false, size = 5 }) => {
  const DATA_TEST_ID = `${isVisible ? "not-" : ""}${OBFUSCATED_TEXT_DATA_ID}`;
  return /* @__PURE__ */ jsx(StyledObfuscatedText, { size, isVisible, "data-testid": DATA_TEST_ID, children });
};
export {
  OBFUSCATED_TEXT_DATA_ID,
  ObfuscatedText
};
